import { AuthService } from './auth.service';
import {
  catchError,
  distinctUntilChanged,
  finalize,
  shareReplay,
  skip,
  switchMap,
  takeWhile,
  tap,
} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, of} from 'rxjs';
import { UserHttpService } from './user-http.service';
import {HttpClient} from "@angular/common/http";
import { SortType } from '@lcms/shared/helpers';
import { MissingFieldsModel } from '../models/missing-fields';
@Injectable({
  providedIn: 'root',
})
export class  UserService {
  constructor(
    private userHttpService: UserHttpService,
    private authService: AuthService,
    private http : HttpClient
  ) {
    this.authService.authStatus$.subscribe(isAuthenticated => {
      if (isAuthenticated) {
        this.getUserRole$.subscribe(role => {
          // console.log("Rôle de l'utilisateur récupéré:", role);
          // Traitez le rôle de l'utilisateur ici
        });
      }
    });
  }
  updateUserSub = new BehaviorSubject<boolean>(false)
  updateUser$ = this.updateUserSub.asObservable()
  terms = new BehaviorSubject<boolean>(false)
 editProfile = new BehaviorSubject<any>(false)
  edit = false
  editProles$ = this.editProfile.asObservable()
  role_id = new BehaviorSubject<any>(null);
    user_id = new BehaviorSubject<any>(null);
  user_id$ = this.user_id.asObservable();

  avatarImageSource = new BehaviorSubject<any>(null);
  avatarImage$ = this.avatarImageSource.asObservable();

  getProfile$: Observable<any> = this.user_id$.pipe(
    distinctUntilChanged(),
    switchMap((id) => {
      return this.userHttpService.getProfile(id ?? '').pipe(
        map((res) => res?.data),
        map((data: any) => {
          return data.map((obj: any) => {
            const { _key, _value, user_id} = obj;
            const newObj = {
              [_key]: _value,
              user_id: user_id ?? id
            };

            return newObj;
          });
        }),
        map((data: any) => {
          return {
            ...data.reduce((acc: any, obj: any) => ({ ...acc, ...obj }), {}),
          };
        })
      );
    }),
    // shareReplay(1)
  );
getAllProfile$ =this.user_id$.pipe(
  distinctUntilChanged(),
  switchMap((id) => {
    return this.userHttpService.getAllProfile(id ?? '').pipe(
      map((res) => res?.data),
      shareReplay(1)
    );
  }),
)

  getAuthUserData$: Observable<any> =this.updateUser$.pipe( distinctUntilChanged(),
    switchMap((refresh) => {
    return   this.userHttpService.getUserData().pipe(
        map((res) => res?.data),
        // takeWhile((data) => !data, true), // stop making requests when data is received
        // shareReplay(1) // cache the result of the HTTP request
      );

    }),shareReplay(1) )

  getUserData$: Observable<any> = this.user_id$.pipe(
    switchMap((id) => {
      return this.userHttpService.getUserData(id ?? '').pipe(
        map((res) => res?.data),
        // takeWhile((data) => !data, true), // stop making requests when data is received
        shareReplay(1) // cache the result of the HTTP request
      );
    })
  );



  getUsers$: Observable<any> = this.userHttpService.getUsers().pipe(
    map((res) => res?.data),
    // takeWhile((data) => !data, true), // stop making requests when data is received
    // shareReplay(1) // cache the result of the HTTP request
  );

  getRole$: Observable<any> = this.user_id$.pipe(
    switchMap((id) => {
      const request = id ? this.userHttpService.getUserRoleByAdmin(id).pipe(map((res) => { return { data: { role: res.data }}})) : this.userHttpService.getUserRole()
      return request.pipe(
        map((res: any) => res?.data?.role?.slug),
        catchError((err) => of(err)),
        finalize(() => this.authService.isLoadingSubject.next(false))
      );
    },)
  );

  // getRole$: Observable<string> = this.userHttpService.getUserRole().pipe(
  //   map((res: any) => res?.data?.role?.slug),
  //   catchError((err) => of(err)),
  //   finalize(() => this.authService.isLoadingSubject.next(false))
  // );


  getAllRoles$ = this.userHttpService.getAllRoles().pipe(map((res) => res?.data))

  getUserRole$: Observable<string> = this.userHttpService.getUserRole().pipe(
    map((res: any) =>( res?.data?.role?.slug || null)),
    // takeWhile((role) => !role, true), // stop making requests when role is received
    shareReplay(1) // cache the result of the HTTP request
  );

  getPaginateUsers(page:number,searchTerm:string):Observable<any>{
    return this.userHttpService.getPaginateUsers(page,searchTerm).pipe(
      map((res) => res?.data)
    )
  }
  checkMissingFields(){
    return this.userHttpService.getUserData().pipe(
      // tap((res) => console.log('checkMissingFields', res)),
      map((data: any)=>data.data.missing_fields as boolean ?? false),
    )
  }

  getMissingFields():Observable<MissingFieldsModel[]>{
    return this.userHttpService.getMissingFields().pipe(
      map((res) => res?.data)
    )
  }
  setMissingFields(payload: any): Observable<any> {
    return this.userHttpService.setMissingFields(payload);
  }
  saveProfile(payload: any) {
    return this.userHttpService.setProfileData(payload)
  }

  saveUser(payload: any) {
    console.log('payload in save user==>', payload);

    return this.userHttpService.setUserData(payload)
  }

  deleteUsers(payload: any) {
    return this.userHttpService.deleteUsers(payload)
  }

  deleteMyAccount(payload: any) {
    return this.userHttpService.deleteMyAccount(payload)
  }

  searchUsers(payload: any) {
    return this.userHttpService.searchUsers(payload).pipe(
      map((res) => res?.data)
    )
  }

  // uploadAvatar(payload: any) {
  //   return this.userHttpService.setAvatar(payload).pipe(
  //     map((res: any) => this.avatarImageSource.next(res.data)),
  //     catchError((error) => of(error)),
  //     tap((response) => {
  //       console.log('res in update avatar==>', response);
  //       if (response instanceof Error) {
  //         throwError(() => {
  //           return response;
  //         });
  //       }
  //     })
  //   );
  // }
  uploadAvatar(payload: any) {
    return this.userHttpService.setAvatar(payload).pipe(
      map((res: any) => this.avatarImageSource.next(res.data)),
      tap((response:any) => {
        console.log('res in update avatar==>', response);
        if (response instanceof Error) {
          throw response;
        }
      })
    );
  }

  toggleActiveUser(payload:any){
    return this.userHttpService.toggleActiveUser(payload)
  }

  getUsersByIds(payload:{users_ids:any[]}):Observable<any>{
    return this.userHttpService.getUsersByIds(payload).pipe(
      map((res:any) => res?.data)
    )
   }

  getRolesByIds(payload:{roles_ids:any[]}):Observable<any>{
    return this.userHttpService.getRolesByIds(payload).pipe(
      map((res:any) => res?.data)
    )
   }

   getUsersByGroupId(payload: any,sort:SortType | null = null , status : any | null = null , filterRole :any | null = null):Observable<any> {
    return this.userHttpService.getUsersByGroups(payload,sort , status , filterRole).pipe(
      map((res) => res?.data)
    )
  }

   getRoleByUserId(user_id:number):Observable<any>{
    return this.userHttpService.getUserRoleByAdmin(user_id)
   }

   updateTerms(payload : any){
    return this.userHttpService.setUserdata(payload)
   }
   HtmlTerms() {
    return this.userHttpService.getTerms().pipe(
      map((res:any) => res?.data)
    )
   }
  disableUser(payload : any) : Observable<any>{
    return this.http.post("/api/auth/v1/set/users/schedule" , payload)
  }

  changePassword(payload : any) : Observable<any>{
    return this.http.post("/api/auth/v1/set/user/password" , payload)
  }


}
